
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Container } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import DashboardCards from '../../components/DashboardCards/DashboardCards';
import ProfileCard from '../../components/ProfileCard/ProfileCard';
import Link from '../../components/Link/Link';
import UpcomingBookingSkeleton from '../../components/Skeleton/ViewBooking/UpcomingBookingSkeleton/UpcomingBookingSkeleton';

import messages from '../../locale/messages';
import { getCardsDetails } from '../../helpers/getCardDetails';
import UpcomingBooking from '../../components/UpcomingBooking/UpcomingBooking';
import useQueryResponse from '../../lib/hooks/useQueryResponse';

import getAllBooking from './getAllBooking.graphql'

import bt from '../../components/commonStyle.css';
import s from './Dashboard.css';


const Dashboard = ({ intl: { formatMessage }, preferredCurrency }) => {
  const cardsDetails = getCardsDetails(formatMessage);
  const { data, loading, refetch } = useQueryResponse({
    query: getAllBooking,
    variables: {
      currentPage: 1,
      requestType: 'upcoming',
      requestCurrency: preferredCurrency
    },
    fetchPolicy: 'network-only',
    ssr: false
  })

  return (
    <div className={'subPageContainer'}>
      <Container>
        <div className='subPageWrapper'>
          <ProfileCard />
          <div>
            <div className={s.dashboardCardBox}>
              {cardsDetails?.map((card, index) => (
                <DashboardCards
                  key={index}
                  cardKey={index}
                  title={card?.title}
                  icon={card?.icon}
                  content={card?.content}
                  link={card?.link}
                />
              ))}
            </div>
            {
              loading ? <UpcomingBookingSkeleton /> : <div className={s.bookingCardContainer}>
                <div className={s.bookingCardTitle}>{formatMessage(messages.currentBookings)}</div>
                <UpcomingBooking
                  loading={loading}
                  refetch={refetch}
                  getAllBooking={{
                    ...data?.getAllBooking,
                    results: data?.getAllBooking?.results?.slice(0, 3)
                  }}
                />
                {data?.getAllBooking?.results?.length > 3 && <div className={s.showMoreLinkContainer}>
                  <Link to={'/bookings/upcoming'} className={bt.commonLinkWithIcon}>
                    <FormattedMessage {...messages.showMoreText} />
                  </Link>
                </div>}
              </div>
            }
          </div>
        </div>
      </Container >
    </div >
  );
}



export default injectIntl(
  withStyles(bt, s)(Dashboard)
);
